import renderInputField from 'components/FormControls/textInput'
import { Button, Grid } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Field, Form, reduxForm } from 'redux-form'
import validator from 'utils/asyncValidator'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import { RECOVER_PASSWORD } from 'modules/Auth/types'
import { validationSchema } from 'modules/Forms/Auth/RecoverPassword/validationSchema'

let PasswordRecoverForm = ({ handleSubmit, submitting, form, onClose, autofill, invalid }) => {
  const { t } = useTranslation()
  const { token, email } = useParams()

  useEffect(() => {
    autofill('email', email)
    autofill('token', token)
  }, [token])

  const submit = async (values, dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        meta: { resolve, reject },
        type: RECOVER_PASSWORD,
        payload: {
          data: values,
          formName: form,
        },
      })
    }).then(onClose)
  }

  return (
    <Form
      onSubmit={handleSubmit(submit)}
      noValidate
    >
      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="email"
          type="text"
          hidden
          disabled
          component={renderInputField}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="token"
          type="text"
          hidden
          disabled
          component={renderInputField}
          t={t}
        />
      </div>

      <div className={'margin-bottom-40'}>
        <Field
          fullWidth
          name="password"
          type="password"
          component={renderInputField}
          t={t}
          label={t('auth::forms.recover_password.fields.password.label')}
          clearButton
          revealButton
        />
      </div>

      {/* <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="password_repeat"
          type="password"
          component={renderInputField}
          t={t}
          label={t('auth::forms.recover_password.fields.password_repeat.label')}
          clearButton
          revealButton
        />
      </div>*/}

      <Grid>
        <Button
          fullWidth
          disabled={invalid || submitting}
          size="l"
          variant="primary"
          type="submit"
        >
          {t('auth::forms.recover_password.form_buttons.submit')}
        </Button>
      </Grid>
    </Form>
  )
}

PasswordRecoverForm = reduxForm({
  form: 'PasswordRecoverForm',
  updateUnregisteredFields: true,
  enableReinitialize: true,
  initialValues: {
    email: '',
    token: '',
    password: '',
    // password_repeat: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
  asyncValidate: validator(validationSchema),
})(PasswordRecoverForm)

PasswordRecoverForm.propTypes = {
  invalid: PropTypes.bool,
  autofill: PropTypes.func,
  onClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  form: PropTypes.string,
}

PasswordRecoverForm.defaultValues = {
  onClose: () => {},
  handleSubmit: () => {},
  submitting: false,
  form: 'PasswordRecoverForm',
}

export default PasswordRecoverForm
